<script>
    import InputStepperButton from './InputStepperButton.svelte';

    export let value;
</script>

<div class="flex flex-col absolute right-0 inset-y-0">
    <InputStepperButton bind:value={value} step={1} type="up" />
    <InputStepperButton bind:value={value} step={-1} type="down" />
</div>